/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest, authorizedApiRequest } from './apiRequest';
import ApiErrorModel from 'models/ApiErrorModel';
// import UserModel from 'models/UserModel';
import AppUtils from 'lib/AppUtils';

const api = {
  forgot: function forgotPassword() {
    return apiRequest('post', 'forgotPassword');
  },
  update: function updateForgotPassword(token) {
    return apiRequest('put', 'forgotPassword', {}, { 'Authorization': `Bearer ${token}` });
  },
  reset: function resetPassword(id) {
    return authorizedApiRequest('put', `users/${id}/password`);
  },
};

const passwordApi = {
  forgot(email, group_id, subdomain) {
    return api.forgot()({
      email,
      subdomain,
      group_id,
    })
    .then(() => null);
  },

  update(token, password) {
    return api.update(token)({
      password,
    })
    .then((res) => res.data.data);
  },

  reset(userId) {
    return api.reset(userId)()
    .then((res) => null);
  },

};

export default passwordApi;
